module.exports = __webpack_public_path__ + "img/26.4cca1a73.png";